import setVariablesDates from "./setVariablesDates.js";
import mainMethod from "./mainMethod.js";
const resetCalendar = (self) => {
  setVariablesDates(self);
  mainMethod(self);
};
export {
  resetCalendar as default
};
